import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { selectFullHistoryArtifactsEnabled } from '../../../shared/features/flags/selectors';
import { i18n } from '../../../shared/helpers/i18n';
import { ARTIFACTS_FILTER_OPTION } from '../constants';

export const useArtifactsOptions = () => {
    const historyFullArtifacts = useSelector(selectFullHistoryArtifactsEnabled);
    return useMemo(
        () => [
            { itemKey: ARTIFACTS_FILTER_OPTION.ALL_CONFS, label: i18n('conferences-history', 'all-confs') },
            ...(historyFullArtifacts
                ? [
                      {
                          itemKey: ARTIFACTS_FILTER_OPTION.WITH_RECORDING,
                          label: i18n('conferences-history', 'with-recording'),
                      },
                      {
                          itemKey: ARTIFACTS_FILTER_OPTION.WITH_SUMMARY,
                          label: i18n('conferences-history', 'with-summary'),
                      },
                  ]
                : []),
            { itemKey: ARTIFACTS_FILTER_OPTION.WITH_REPORT, label: i18n('conferences-history', 'with-report') },
            { itemKey: ARTIFACTS_FILTER_OPTION.NO_ARTIFACTS, label: i18n('conferences-history', 'no-artifacts') },
        ],
        [historyFullArtifacts]
    );
};
